export default {
    getObjKey(obj,nestedKey) {
        if (!obj) {
            return null;
        }
        return nestedKey.split(".").reduce(function(updatingObj, key) {
            return (typeof updatingObj == "undefined" || updatingObj === null) ? updatingObj : updatingObj[key];
        }, obj);
    },
    setObjKey(obj,nestedKey,value) {
        let keys = nestedKey.split('.');
        let tempObj=obj
        for (let i=0;i<keys.length-1;i++) {
            let key=keys[i]
            if (!Object.hasOwn(tempObj,key) || (Object.hasOwn(tempObj,key) && !tempObj[key])) {
                tempObj[key]={};
            }
            tempObj=tempObj[key]
        }
        tempObj[keys[keys.length - 1]] = value;
        return obj
    },
}